export const convertDateToUTCISO = (date: Date) => {  
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(),
                  date.getDate(), 0,
                  0, 0));
    return utcDate.toISOString().substring(0, 10);
  }